import { FacturaWithRelations } from '@/types/invoices/facturaList';
import { FacturasListActions, facturasListTypes } from '../types/facturasListTypes';

interface FacturasListState {
  facturasList: FacturaWithRelations[];
  loading: boolean;
  count: number;
  page: number;
  dateRange: [string, string];
  currentFilter: any[][];
}

const getInitialDateRange = (): [string, string] => {
  const now = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  
  return [oneMonthAgo.toISOString(), now.toISOString()];
};

// Matriz de filtros vacía
const getInitialFilter = (): any[][] => [[], [], [], [], [], [], [], [], [], [], [], []];

const initialState: FacturasListState = {
  facturasList: [],
  loading: false,
  count: 0,
  page: 0,
  dateRange: getInitialDateRange(),
  currentFilter: getInitialFilter(),
};

export const facturasListReducer = (state = initialState, action: FacturasListActions): FacturasListState => {
  switch (action.type) {
    case facturasListTypes.startLoadingFacturasList:
      return { ...state, loading: true };
    case facturasListTypes.finishLoadingFacturasList:
      return { ...state, loading: false };
    case facturasListTypes.facturasListLoad:
      return { ...state, facturasList: action.payload };
    case facturasListTypes.facturasListSetCount:
      return { ...state, count: action.payload };
    case facturasListTypes.facturasListSetPage:
      return { ...state, page: action.payload };
    case facturasListTypes.facturasListSetDateRange:
      return { ...state, dateRange: action.payload };
    case facturasListTypes.facturasListResetPage:
      return { ...state, page: 0 };
    case facturasListTypes.facturasListSetFilter:
      return { ...state, currentFilter: action.payload };
    default:
      return state;
  }
};

